<button
  odxButton
  variant="secondary"
  (click)="toggleVisibility()"
  [odxTooltip]="visible ? tooltipTextHideCategory : tooltipTextShowCategory"
  [odxTooltipOptions]="{ position: 'bottom' }"
>
  <odx-icon [name]="visible ? 'view' : 'view-off'" size="medium"></odx-icon>
</button>
